export default "__VITE_ASSET__ni63Csm6__"